import axios from "../../publicApi";

export const unsubscribeEmail = (userId: string) =>
  axios.patch("users/unsubscribe-emails", {
    uuid: userId,
  });
